import { createRouter, createWebHistory } from "vue-router";
import Charlas from "@/views/Charlas.vue"
import About from "@/views/About.vue";
import Practicantes from "@/views/Practicantes.vue";
import Home from "@/views/Home.vue";
import Projects from "@/views/Projects.vue";
import NotFound from "@/views/NotFound.vue";
import Resultados from "@/views/Resultados.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: "/acerca-de/acerca-de"
  },
  {
    path: "/acerca-de/:about",
    name: "Programa de Prácticas Pre Profesionales",
    component: About
  },
  {
    path: "/nuestros-practicantes/:type/:anho",
    name: "Practicantes",
    component: Practicantes
  },
  {
    path: "/charlas",
    name: "Charlas",
    component: Charlas
  },
  {
    path: "/resultados",
    name: "Resultados",
    component: Resultados
  },
  {
    path: "/proyectos/:type",
    name: "Projects",
    component: Projects
  },
  {
    path: "/acerca-de/postula-aqui",
    beforeEnter() { location.href= 'https://www.igp.gob.pe/convocatorias/'}
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: NotFound
  }
];

const router = createRouter({
  mode: 'history',
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
